import { useState, useEffect, ChangeEvent } from 'react';
import { Row, Col } from 'react-bootstrap'
import Card from '../../../../components/Card'
import { DetailItem } from '../../../../features/details';
import { Terminal, VmcStatusDto, Transaction } from '../../../../services/openapi';
import { getPropertyInfo as getTerminalPropertyInfo, getTerminalByPoi } from '../../../../services/api/terminal';
import { getPropertyInfo as getVmcPropertyInfo, getVmcByVmcId } from '../../../../services/api/vmc';
import { getPropertyInfo } from '../../../../services/api/transaction' 
import { useNavigate } from "react-router-dom";
import { NotImplementedWarningModal } from '../../../../components/NotImplementedWarningModal';
import { setPendingSelectedId } from '../../../../hooks/pendingSelection';
import { useKeycloak } from '@react-keycloak/web'
import { useTranslation } from 'react-i18next'; 
import { PropertyInfo } from '../../../../services/openapi/models/PropertyInfo';
import i18n from '../../../../i18n';
import { NavContext } from '../../../../components/dto/NavContext';
import { popNavContext, pushNavContext } from '../../../../hooks/navContext';

const TransactionDetails = () => {
    const [transaction, setTransaction] = useState<any>();
    const [props, setProps] = useState<Record<string, PropertyInfo>>();
    const [showInputEle, setShowInputEle] = useState<boolean>(false);
    const [showModal, setShowModal] = useState(false);

    const setTransactionData = (data: Transaction) => {
        localStorage.setItem('Transaction', JSON.stringify(data));
    }

    const { keycloak, initialized } = useKeycloak();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const setTerminalData = (data: Terminal) => {
        localStorage.setItem('Terminal', JSON.stringify(data));
    }

    const setVmcData = (data: VmcStatusDto) => {
        localStorage.setItem('Vmc', JSON.stringify(data));
    }

    const navigateBack = () => {
        const nav = popNavContext();

        // Opened from the details of an alert, and that alert is still the one shown there
        if (nav?.from === 'details/alert' && nav.id != null) {
            const alert = JSON.parse(localStorage.getItem('Alert') || 'null');
            if (alert && alert.id === nav.id) {
                navigate('/dashboard/details/alert');
                return;
            }
        }

        setPendingSelectedId("transactions", transaction?.id);
        navigate('/dashboard/lists/transactions');
    };

    const handleFieldClick = async (fieldName: string) => {
        const navContext: NavContext = {
            from: 'details/transaction',
            id: transaction.id,
        };

        switch (fieldName) {
            case 'transaction.terminalDescription':
            case 'transaction.terminalIdentifier':
            if (transaction?.terminalIdentifier) {
                const t = await getTerminalByPoi(keycloak.token ?? '', transaction.terminalIdentifier);
                const p = await getTerminalPropertyInfo(keycloak.token ?? '');
                t.propertyNames = p;
                setTerminalData(t);
                pushNavContext(navContext);
                navigate(`/dashboard/details/terminal`);
            }
            break;

            case 'transaction.vmcName':
            if (transaction?.vmcId) {
                const v = await getVmcByVmcId(keycloak.token ?? '', transaction.vmcId, i18n.language+'-'+i18n.language);
                const p = await getVmcPropertyInfo(keycloak.token ?? '');
                v.propertyNames = p;
                setVmcData(v);
                pushNavContext(navContext);
                navigate(`/dashboard/details/vmc`);
            }
            break;
            // Add more cases as needed
            default:
            // No action
            break;
        }
    };

    useEffect(() => {
        let cancelled = false;

        const loadTransaction = async () => {
            if (transaction != null) return;

            const json = localStorage.getItem("Transaction");
            if (!json) return;

            const item = JSON.parse(json);
            let props = item?.propertyNames as Record<string, PropertyInfo> | undefined;

            if (props == null) {
                const pi = localStorage.getItem("PropertyInfo");

                if (pi && pi !== "undefined") {
                    props = JSON.parse(pi);
                } else {
                    try {
                        props = await getPropertyInfo(keycloak.token ?? "");

                        // Optional: cache the fetched data
                        localStorage.setItem("PropertyInfo", JSON.stringify(props));
                    } catch (error) {
                        console.error("Could not load property info:", error);
                        return;
                    }
                }
            }

            // Avoid setting state if the component has unmounted.
            if (!cancelled) {
                setTransaction(item);
                setProps(props);
            }
        };

        void loadTransaction();

        return () => {
            cancelled = true;
        };
    }, [transaction, keycloak.token]);

    return (
        <>
            <div className="">
                <NotImplementedWarningModal
                    showModal={showModal}
                    handleClose={() => {
                        setShowModal(false);
                    }}
                />
            </div>
            <Row className="">
                <Col className="">
                    <Card className="rounded">
                        <Card.Body className="">
                            
                                <Row className="d-none d-md-block">
                                    <Col>&nbsp;</Col>
                                </Row>
                                <Row className="d-none d-md-block">
                                    <Col>&nbsp;</Col>
                                </Row>
                                <Row className="">
                                    <Col sm="12" className="">
                                        <h4 className="mb-2 qvend-title">{t("transactiedetails")}</h4>
                                    </Col>
                                </Row>
                                <Row className="">
                                    <Col sm="12" xs="12" className="mt-2">
                                        <div className="table-responsive-lg" style={{ overflowX: 'hidden' }}>
                                            <div>
                                            {transaction && props && Object.entries<any>(transaction).filter(([key, value]) => props[key] !== undefined && props[key] !== null && (props[key].editType !== '' || (props[key].editType === ''))).sort((a, b) => props[a[0]].sortOrderLevel - props[b[0]].sortOrderLevel).map(([key, value], index) => {
                                                const isClickable =
                                                    key === 'terminalDescription' ||
                                                    key === 'terminalIdentifier' ||
                                                    (key === 'vmcName' && transaction.vmcId != null);
                                                return(<DetailItem key={props[key].sortOrderLevel} propertyName={props[key].name} defaultValue={typeof value == "boolean" ? value ? t('general.yes') : t('general.no') : value} rowColor={index % 2 ? "#cfd5ea" : "#e9ebf5"} editType={props[key].editType} pattern={props[key].valPattern} hideOnNull={props[key].hideOnNull}
                                                        handleDoubleClick={() => setShowInputEle(true)}
                                                        onFieldClick={handleFieldClick}
                                                        isClickable={isClickable}
                                                    handleChange={(e: ChangeEvent<HTMLInputElement>) => { transaction[key] = (e.target.value); setTransaction(transaction); }} showInputEle={showInputEle} enumMap={props[key].enumMap} conditionToShowReferenceValue={transaction[props[key].conditionToShowFieldName]} conditionToShowValue={props[key].conditionToShowValue}></DetailItem>
                                                )})}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>                                                                
                                <Row style={{ paddingTop: "3px" }}>
                                    <Col>
                                        <button type="button" className="btn btn-fixed-width" style={{ fontSize: '11px', backgroundColor: "red" }} onClick={navigateBack}>{t("button.back")}</button>
                                    </Col>
                                    <Col className="text-end">                                        
                                    </Col>
                                </Row>
                            
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default TransactionDetails;